import { Unit, BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { PoundLb } from "./mass";
// Per mass
export var OnePerKilogram = UnitDivide.dimensionlessByMass("OnePerKilogram", Unit.One, BaseUnits.Kilogram);
export var OnePerPoundLb = UnitDivide.dimensionlessByMass("OnePerPoundLb", Unit.One, PoundLb);
//# sourceMappingURL=dimensionless-per-mass.js.map